const toggleVisibility = (element) => {
    if (element) element.classList.toggle('d-none')
}

const appendCloseButton = (form) => {
    let header
    if (form) {
        header = form.querySelector('h1')
        if (!header) {
            header = form.querySelector('h2')
        }
        if (!header) {
            header = form.querySelector('h3')
        }
        if (header) {
            header.addEventListener('click', (event) => {
                event.preventDefault()
                form.classList.add('hidden-panel')
                toggleVisibility(document.querySelector('.gray-cover'))
            })
        }
    }
}

export const fillAdvertName = () => {
    const detail = document.querySelector('.common-catalog.detail')
    if (detail) {
        const head = detail.querySelector('h1.item-name').textContent
        const value = `${window.location.origin}${window.location.pathname}`
        for (const element of document.querySelectorAll('input[kariera_item_field]')) {
            element.value = value
        }
        for (const element of document.querySelectorAll('input[kariera_job_position_field]')) {
            element.value = head
        }
    }
}

export const initForm = () => {
    const button = document.querySelector('a.respond-ad')
    const form_first = document.querySelector('.content-published form.submit-by-fetch')
    const form_second = document.querySelector('.content-published form.additional-from')
    appendCloseButton(form_first)
    appendCloseButton(form_second)
    if (button && form_first) {
        button.addEventListener('click', (event) => {
            event.preventDefault()
            form_first.classList.remove('hidden-panel')
            toggleVisibility(document.querySelector('.gray-cover'))
        })
    }
}

// Funcion is available for the entire document.
document.processSecondFrom = function(previous_form, data) {
    // Pass on data from previous post.
    for (const input of document.querySelectorAll('input.aldryn-forms-field-ident')) {
        input.value = data.post_ident
    }
    // Hide first form
    previous_form.classList.add('hidden-panel')
    // Display second form
    const form = document.querySelector('form.additional-from')
    if (form) {
        form.classList.remove('hidden-panel')
    }
}
